import React from 'react';
import SafeHtml from '../../components/SafeHtml';

const AccordionRenderer = ({ block }) => {
  const items = block.items || [];
  return (
    <div className="accordion-container">
      {items.map((item) => (
        <details key={item.id} className="accordion-item">
          <summary className="accordion-header">
            <h3 className="accordion-title">{item.title}</h3>
            <div className="chevron" aria-hidden="true"></div>
          </summary>
          <SafeHtml
            className="accordion-content rich-editor-content"
            html={item.content}
          />
        </details>
      ))}
    </div>
  );
};

export default AccordionRenderer;
